import { EXCEL_TYPE } from '@op/constants';
import { pressTimeGrouping, sortTimeArrayListFunc } from '@op/utils';

export function downloadFile(resData: any, filename: string, mimeType?: string) {
  if (resData) {
    const blob = new Blob([resData], {
      type: mimeType || EXCEL_TYPE,
    });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = checkFileName(filename);
    link.click();
  }
}

/**
 * window操作系统文件名不能含有 \ / : * ? " < > |
 * mac操作系统文件名不能以.开头
 * linux和Mac基本一直*
 * @param fileName
 * @return
 */
function checkFileName(fileName: string) {
  const reg = /\\|\/|\:|\*|\?|\"|\<|\>|\.|\|/g;
  const _name = fileName.replace(reg, '');
  return _name;
}

/**
 * 50000 转为 50,000
 * @param number 
 * @returns 
 */
export const transNumber = (number: number) => {
  return number.toLocaleString();
};

export const addTotalForDownload = (list: Array<any>) => {
  if (!Array.isArray(list)) {
    return list;
  }
  const timeGroup: any = pressTimeGrouping(list);
  const keys = Object.keys(timeGroup || {});
  keys.sort(sortTimeArrayListFunc('desc'));
  const allList = keys.map((key) => {
    const newList: Array<any> = timeGroup[key];
    const total = newList.reduce((pre, cur) => {
      return pre + cur?.value || 0;
    }, 0);
    newList.unshift({
      name: 'Total',
      time: newList[0].time,
      value: total,
    });
    return newList;
  });
  return allList.flat(Infinity);
};
